/** @file sortImpostors: painter's order, far first by quadDepth, exact ties by list index. */
import type { ImpostorList } from '@zilo/pose3d-render-core/contract';
import { quadDepth } from '@zilo/pose3d-render-core/depth/quadDepth';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';

/** Indices 0..count-1 sorted by `quadDepth` descending (far first); equal depths keep list order. */
export function sortImpostors(list: ImpostorList, count: number, view: View): number[] {
  const depth = Array.from({ length: count }, (_, i) => quadDepth(list, i, view));
  return Array.from({ length: count }, (_, i) => i).sort((a, b) => (depth[b] ?? 0) - (depth[a] ?? 0) || a - b);
}
